import { createApi } from '@reduxjs/toolkit/query/react'
import { staggeredBaseQueryWithBailOut } from '../libs/services'
import { unversionedApiUrl } from './common'

const TAG = 'fhir-insurance-providers'
export const fhirInsuranceProvidersApi = createApi({
	reducerPath: 'fhirInsuranceProvidersApi',
	baseQuery: staggeredBaseQueryWithBailOut(`${unversionedApiUrl}`),
	tagTypes: [TAG],
	endpoints: builder => ({
		getInsuranceProviders: builder.query<string[], void>({
			query: () => ({
				url: `/v1/fhir-insurance-providers`,
			}),
			providesTags: [TAG],
		}),
	}),
})

export const { useGetInsuranceProvidersQuery } = fhirInsuranceProvidersApi
